export enum EnrollmentStatus {
    NOT_STARTED = 'NOT_STARTED',
    STARTED = 'STARTED',
    COMPLETED = 'COMPLETED',
    INACTIVE = 'INACTIVE',
    UNKNOWN = 'UNKNOWN'
}